import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Projet } from '../entity/Projet';
 import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
 
 @Injectable( )
export class ProjetService {

private apiUrl= environment.restApi;
private apiProjet=`${this.apiUrl}projet` ;


  constructor( 
    private http:HttpClient ) { 

  }

getProjectList():Observable<any>{
 return this.http.get<Projet>(this.apiProjet) .pipe(
  tap(_ => this.notify('fetched projects', 'GET')),
  catchError(this.handleError('get Projects', 'GET'))
);
}






    /**
     * Prepare an error handler for failed HTTP requests.
     * That handler extracts the error message and logs it.
     * It also adds the message to the errors$ observable to which the caller
     * may listen and react.
     * @param operation The name/description of the operation that failed
     * @param method The HTTP method for the failed HTTP request
     */
    protected handleError(operation: string, method: string) {
      return function errorHandler(res: HttpErrorResponse) {
          this.logger.error(res);
          const eMsg = res.message || '';
          const error = `${this.entityNamePlural} ${operation} Error${
              eMsg ? ': ' + eMsg : ''
              }`;
          this.notify(error, method);
      }.bind(this);
  }

  protected notify(message: string, method: string) {
 
  }

}
